/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for single estimate operations (GET, POST, PATCH).
 * @export
 * @interface EstimateResponse
 */
export interface EstimateResponse {
    /**
     * 
     * @type {number}
     * @memberof EstimateResponse
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateResponse
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateResponse
     */
    documentId?: number | null;
    /**
     * Source system that generated the estimate
     * @type {string}
     * @memberof EstimateResponse
     */
    sourceSystem: EstimateResponseSourceSystemEnum;
    /**
     * Type of estimate
     * @type {string}
     * @memberof EstimateResponse
     */
    kind: EstimateResponseKindEnum;
    /**
     * Subtotal in cents
     * @type {number}
     * @memberof EstimateResponse
     */
    subtotalCents: number;
    /**
     * Taxes in cents
     * @type {number}
     * @memberof EstimateResponse
     */
    taxesCents: number;
    /**
     * Depreciation in cents
     * @type {number}
     * @memberof EstimateResponse
     */
    depreciationCents: number;
    /**
     * Total value in cents
     * @type {number}
     * @memberof EstimateResponse
     */
    totalCents: number;
    /**
     * 
     * @type {Date}
     * @memberof EstimateResponse
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof EstimateResponse
     */
    readonly documentFilename?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateResponse
     */
    readonly roomCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EstimateResponse
     */
    readonly lineItemCount?: number | null;
}


/**
 * @export
 */
export const EstimateResponseSourceSystemEnum = {
    Xactimate: 'xactimate',
    Symbility: 'symbility',
    Other: 'other'
} as const;
export type EstimateResponseSourceSystemEnum = typeof EstimateResponseSourceSystemEnum[keyof typeof EstimateResponseSourceSystemEnum];

/**
 * @export
 */
export const EstimateResponseKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type EstimateResponseKindEnum = typeof EstimateResponseKindEnum[keyof typeof EstimateResponseKindEnum];


/**
 * Check if a given object implements the EstimateResponse interface.
 */
export function instanceOfEstimateResponse(value: object): value is EstimateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('sourceSystem' in value) || value['sourceSystem'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('subtotalCents' in value) || value['subtotalCents'] === undefined) return false;
    if (!('taxesCents' in value) || value['taxesCents'] === undefined) return false;
    if (!('depreciationCents' in value) || value['depreciationCents'] === undefined) return false;
    if (!('totalCents' in value) || value['totalCents'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function EstimateResponseFromJSON(json: any): EstimateResponse {
    return EstimateResponseFromJSONTyped(json, false);
}

export function EstimateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'sourceSystem': json['sourceSystem'],
        'kind': json['kind'],
        'subtotalCents': json['subtotalCents'],
        'taxesCents': json['taxesCents'],
        'depreciationCents': json['depreciationCents'],
        'totalCents': json['totalCents'],
        'createdAt': (new Date(json['createdAt'])),
        'documentFilename': json['documentFilename'] == null ? undefined : json['documentFilename'],
        'roomCount': json['roomCount'] == null ? undefined : json['roomCount'],
        'lineItemCount': json['lineItemCount'] == null ? undefined : json['lineItemCount'],
    };
}

export function EstimateResponseToJSON(json: any): EstimateResponse {
    return EstimateResponseToJSONTyped(json, false);
}

export function EstimateResponseToJSONTyped(value?: Omit<EstimateResponse, 'id'|'createdAt'|'documentFilename'|'roomCount'|'lineItemCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'documentId': value['documentId'],
        'sourceSystem': value['sourceSystem'],
        'kind': value['kind'],
        'subtotalCents': value['subtotalCents'],
        'taxesCents': value['taxesCents'],
        'depreciationCents': value['depreciationCents'],
        'totalCents': value['totalCents'],
    };
}

